export const messages = {
  en: {
    addEquipmentAccount: {
      title: 'Add Equipment',
      machineName: 'Equipment Name',
      machineNamePlaceholder: 'Required, please enter equipment name',
      machineCode: 'Equipment Code',
      machineCodePlaceholder: 'Required, please enter equipment code',
      importanceLevel: 'Importance Level',
      importanceLevelPlaceholder: 'Required, please select importance level',
      state: 'Usage Status',
      statePlaceholder: 'Required, please select usage status',
      brand: 'Brand',
      brandPlaceholder: 'Optional, please enter brand',
      model: 'Model',
      modelPlaceholder: 'Optional, please enter model',
      netWorth: 'Net Worth',
      netWorthPlaceholder: 'Optional, please enter net worth',
      locationDetail: 'Location Detail',
      locationDetailPlaceholder: 'Optional, please enter location detail',
      firstEnableTime: 'First Enable Time',
      firstEnableTimePlaceholder: 'Optional, please select first enable time',
      warrantyDeadline: 'Warranty Deadline',
      warrantyDeadlinePlaceholder: 'Optional, please select warranty deadline',
      usefulLife: 'Useful Life (Years)',
      usefulLifePlaceholder: 'Optional, please enter useful life',
      purchasePrice: 'Purchase Price',
      purchasePricePlaceholder: 'Optional, please enter purchase price',
      useUserName: 'User',
      useUserNamePlaceholder: 'Required, please select user',
      chargeUseName: 'Responsible Person',
      chargeUseNamePlaceholder: 'Required, please select responsible person',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark',
      validate: {
        machineNameRequired: 'Equipment name is required',
        machineCodeRequired: 'Equipment code is required',
        importanceLevelRequired: 'Importance level is required',
        stateRequired: 'Usage status is required',
        useUserNameRequired: 'User is required',
        chargeUseNameRequired: 'Responsible person is required'
      },
      saveSuccess: 'Add successfully',
      saveFailed: 'Add failed',
      page: {
        title: 'Add Equipment',
        subtitle: 'Register equipment ledger under selected category',
        infoTitle: 'Equipment Information'
      }
    }
  },
  zh: {
    addEquipmentAccount: {
      title: '添加设备',
      machineName: '设备名称',
      machineNamePlaceholder: '必填，请填写设备名称',
      machineCode: '设备编码',
      machineCodePlaceholder: '必填，请填写设备编码',
      importanceLevel: '重要等级',
      importanceLevelPlaceholder: '必填，请选择重要等级',
      state: '使用状态',
      statePlaceholder: '必填，请选择使用状态',
      brand: '设备品牌',
      brandPlaceholder: '选填，请填写设备品牌',
      model: '设备型号',
      modelPlaceholder: '选填，请填写设备型号',
      netWorth: '资产净值',
      netWorthPlaceholder: '选填，请填写资产净值',
      locationDetail: '位置详情',
      locationDetailPlaceholder: '选填，请填写位置详情',
      firstEnableTime: '首次启用时间',
      firstEnableTimePlaceholder: '选填，请填写首次启用时间',
      warrantyDeadline: '保修截止日期',
      warrantyDeadlinePlaceholder: '选填，请填写保修截止日期',
      usefulLife: '使用年限(年)',
      usefulLifePlaceholder: '选填，请填写使用年限',
      purchasePrice: '采购价格',
      purchasePricePlaceholder: '选填，请填写采购价格',
      useUserName: '使用人',
      useUserNamePlaceholder: '必填，请填写使用人',
      chargeUseName: '责任人',
      chargeUseNamePlaceholder: '必填，请填写责任人',
      remark: '备注',
      remarkPlaceholder: '选填，请填写备注',
      validate: {
        machineNameRequired: '设备名称不能为空',
        machineCodeRequired: '设备编码不能为空',
        importanceLevelRequired: '重要等级不能为空',
        stateRequired: '使用状态不能为空',
        useUserNameRequired: '使用人不能为空',
        chargeUseNameRequired: '责任人不能为空'
      },
      saveSuccess: '添加成功',
      saveFailed: '添加失败',
      page: {
        title: '添加设备',
        subtitle: '在所选分类下登记设备台账',
        infoTitle: '设备信息'
      }
    }
  }
}